import SailsService from './sails.service';

/* @ngInject */
export default class LicenseTypeService extends SailsService {
  constructor() {
    super('licenseType');
    this.store = super.model();

    this.create = super.post;
    this.get = super.get;
    this.update = super.put;
  }

  /**
   * Model reference
   * This should *ALWAYS* be awaited, in case a `get` is needed
   *
   * @readonly
   * @memberof LicenseTypeService
   * @returns {object | Promise<object>}
   */
  get model() {
    return _.isEmpty(this.store.byId) ?
      this.get().then(() => this.store) :
      this.store;
  }

  destroy(id) {
    return super.delete(id);
  }
}
